import { useIsDesktop, WSScreen } from "@wingspanhq/fe-component-library";
import React, { useEffect } from "react";
import { Redirect, Route, RouteComponentProps, Switch } from "react-router-dom";
import { ApiKeys } from "../../modules/ApiKeys";
import { PATH_API_KEYS } from "../../modules/ApiKeys/paths";
import {
  PATH_SETTINGS_PAYMENT_METHODS,
  PATH_SETTINGS_PAYROLL,
  PATH_SETTINGS_TAX_PROFILE
} from "../../modules/Settings/paths";
import { RouteAccount } from "../../modules/Settings/routes/RouteAccount";
import { RoutePaymentMethods } from "../../modules/Settings/routes/RoutePaymentMethods";
import { RoutePayroll } from "../../modules/Settings/routes/RoutePayroll";
import { RouteTaxProfile } from "../../modules/Settings/routes/RouteTaxProfile";
import { Worksites } from "../../modules/Worksites";
import { PATH_SETTINGS_WORKSITES } from "../../modules/Worksites/paths";
import { AccountStakeholders } from "../../modules/AccountStakeholders";
import { PATH_ACCOUNT_STAKEHOLDERS } from "../../modules/AccountStakeholders/paths";
import { IntegrationsTab } from "./Integrations/IntegrationsTab";
import { IntegrationsQuickbooksSyncActivities } from "./Integrations/quickbooks/IntegrationsQuickbooksSyncActivities";
import { QuickbooksSetupStep1 } from "./Integrations/quickbooks/QuickbooksSetupStep1";
import { QuickbooksSetupStep2 } from "./Integrations/quickbooks/QuickbooksSetupStep2";
import { QuickbooksSetupStep3 } from "./Integrations/quickbooks/QuickbooksSetupStep3";
import { QuickbooksSetupStep4 } from "./Integrations/quickbooks/QuickbooksSetupStep4";
import { QuickbooksSetupStep5 } from "./Integrations/quickbooks/QuickbooksSetupStep5";
import { QuickbooksSetupStep6 } from "./Integrations/quickbooks/QuickbooksSetupStep6";
import { QuickbooksSetupStep7 } from "./Integrations/quickbooks/QuickbooksSetupStep7";
import { QuickbooksSetupStep8 } from "./Integrations/quickbooks/QuickbooksSetupStep8";
import { NotificationsTab } from "./NotificationsTab";

export type SettingsProps = RouteComponentProps;

export const SettingsMain: React.FC<SettingsProps> = ({
  location: { hash }
}) => {
  const isDesktop = useIsDesktop();

  useEffect(() => {
    const timer = setTimeout(() => {
      const id = hash.replace("#", "");
      const element = document.getElementById(id);

      element?.scrollIntoView();
    }, 2000);

    return () => {
      clearTimeout(timer);
    };
  }, [hash]);

  return (
    <Switch>
      <Route path="/member/settings/account" component={RouteAccount} />
      <Route path={PATH_SETTINGS_PAYROLL} component={RoutePayroll} />
      {/* Integrations */}
      <Redirect
        path="/member/settings/integrations/quickbooks/setup"
        exact
        to="/member/settings/integrations/quickbooks/setup/step/1"
      />
      <Route
        path="/member/settings/integrations/quickbooks/setup/step/1"
        exact
        component={QuickbooksSetupStep1}
      />
      <Route
        path="/member/settings/integrations/quickbooks/setup/step/2"
        exact
        component={QuickbooksSetupStep2}
      />
      <Route
        path="/member/settings/integrations/quickbooks/setup/step/3"
        exact
        component={QuickbooksSetupStep3}
      />
      <Route
        path="/member/settings/integrations/quickbooks/setup/step/4"
        exact
        component={QuickbooksSetupStep4}
      />
      <Route
        path="/member/settings/integrations/quickbooks/setup/step/5"
        exact
        component={QuickbooksSetupStep5}
      />
      <Route
        path="/member/settings/integrations/quickbooks/setup/step/6"
        exact
        component={QuickbooksSetupStep6}
      />
      <Route
        path="/member/settings/integrations/quickbooks/setup/step/7"
        exact
        component={QuickbooksSetupStep7}
      />
      <Route
        path="/member/settings/integrations/quickbooks/setup/step/8"
        exact
        component={QuickbooksSetupStep8}
      />
      <Route
        path="/member/settings/integrations/quickbooks/history"
        component={IntegrationsQuickbooksSyncActivities}
      />
      <Route path="/member/settings/integrations" component={IntegrationsTab} />

      {/* Everythings else */}

      <Route path={PATH_SETTINGS_WORKSITES} component={Worksites} />
      <Route path={PATH_SETTINGS_TAX_PROFILE} component={RouteTaxProfile} />
      <Route
        path="/member/settings/notifications"
        component={NotificationsTab}
      />
      <Route path={PATH_ACCOUNT_STAKEHOLDERS} component={AccountStakeholders} />
      <Route path={PATH_API_KEYS} exact={!isDesktop} component={ApiKeys} />
      <Route
        path={PATH_SETTINGS_PAYMENT_METHODS}
        component={RoutePaymentMethods}
      />

      <WSScreen.Desktop>
        <Redirect from="/member/settings" exact to="/member/settings/account" />
      </WSScreen.Desktop>
    </Switch>
  );
};
